(function () {
  var OPEN_CLASS = 'zoci-sidebar-open';

  function setExpanded(expanded) {
    document.documentElement.classList.toggle(OPEN_CLASS, expanded);
    document.querySelectorAll('.zoci-nav-toggle').forEach(function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function toggleSidebar() {
    setExpanded(!document.documentElement.classList.contains(OPEN_CLASS));
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-zoci-sidebar-toggle]');
    if (!toggle) return;
    event.preventDefault();
    toggleSidebar();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.documentElement.classList.contains(OPEN_CLASS)) {
      setExpanded(false);
    }
  });
})();
